import { useMutation } from '@tanstack/react-query';
import { useStandardToast } from '@cks-internal/react-base';

import { ActivityEndpoints } from '../../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../../lib/axios';

export function useResendCorporatePaymentEmailMutation() {
  const toast = useStandardToast();

  return useMutation({
    mutationFn: async (vars: { activityId: number }) => {
      return await getAxios().post(ActivityEndpoints.paymentCard.resendCorporatePaymentEmail(vars.activityId));
    },
    onSuccess: () => {
      toast.successToast('Corporate payment email has been resent');
    },
    onError: () => {
      toast.errorToast('Failed to resend corporate payment email');
    }
  });
}
